import { Link } from "react-router-dom";
import { ArrowUpRight } from "lucide-react";
import { FadeIn, MaskedLines, Overline } from "@/components/Motion";

export default function CTABand({
  overline = "Partnership",
  lines = ["Build the future of", "access with ACTIVE."],
  sub = "",
  primary = { to: "/contact?type=distributor", label: "Become an ACTIVE Distributor", testid: "cta-band-distributor" },
  secondary = { to: "/contact?type=sales", label: "Talk with Business Development", testid: "cta-band-bd" },
}) {
  return (
    <section className="bg-obsidian noise-dark" data-testid="cta-band">
      <div className="relative z-[2] max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-28 sm:py-36">
        <FadeIn>
          <Overline light>{overline}</Overline>
        </FadeIn>
        <h2 className="mt-6 font-display text-4xl sm:text-5xl lg:text-6xl font-bold tracking-tighter text-white leading-[0.98] max-w-4xl">
          <MaskedLines lines={lines} />
        </h2>
        {sub && (
          <FadeIn delay={0.15}>
            <p className="mt-5 max-w-xl text-base md:text-lg text-slate-400 leading-relaxed">{sub}</p>
          </FadeIn>
        )}
        <FadeIn delay={0.2}>
          <div className="mt-10 flex flex-col sm:flex-row gap-4">
            <Link
              to={primary.to}
              data-testid={primary.testid}
              className="inline-flex items-center justify-center gap-2 rounded-full bg-white text-obsidian text-sm font-medium px-8 py-4 hover:bg-signal hover:text-white transition-colors duration-300"
            >
              {primary.label} <ArrowUpRight size={15} />
            </Link>
            <Link
              to={secondary.to}
              data-testid={secondary.testid}
              className="inline-flex items-center justify-center gap-2 rounded-full border border-white/20 text-white text-sm font-medium px-8 py-4 hover:border-white/60 transition-colors duration-300"
            >
              {secondary.label}
            </Link>
          </div>
        </FadeIn>
      </div>
    </section>
  );
}
